"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var session = _interopRequireWildcard(require("./domains/session"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var _session$selectors = session.selectors,
  selectContext = _session$selectors.context,
  selectProfile = _session$selectors.profile,
  selectIsStudio = _session$selectors.isStudio,
  selectPublicPortalDomain = _session$selectors.publicPortalDomain,
  selectIsPublicPortal = _session$selectors.isPublicPortal,
  selectIsPIRAEnabled = _session$selectors.isPIRAEnabled,
  selectFeatureFlag = _session$selectors.featureFlag,
  selectFeatureFlags = _session$selectors.featureFlags;
var _session$actions = session.actions,
  setUserProperty = _session$actions.setUserProperty,
  setSession = _session$actions.setSession;
var selectors = {
  selectContext: selectContext,
  selectProfile: selectProfile,
  selectIsStudio: selectIsStudio,
  selectPublicPortalDomain: selectPublicPortalDomain,
  selectIsPublicPortal: selectIsPublicPortal,
  selectIsPIRAEnabled: selectIsPIRAEnabled,
  selectFeatureFlag: selectFeatureFlag,
  selectFeatureFlags: selectFeatureFlags
};
var actions = {
  setUserProperty: setUserProperty,
  setSession: setSession
};
var _default = exports.default = {
  actions: actions,
  selectors: selectors
};
//# sourceMappingURL=session.js.map